import type { LocaleCopy } from '../types';
import { homeEn } from './home';
import { chromeEn } from './chrome';
import { aboutEn } from './about';
import { allergensEn } from './allergens';

export const en: LocaleCopy = {
  home: homeEn,
  chrome: chromeEn,
  about: aboutEn,
  allergens: allergensEn,
};
